import { RootState } from 'configs/redux';

export const APIErrorSelector = (state: RootState) => state.APIError;
